import { Component, OnInit, Input, ViewChild, EventEmitter, ViewEncapsulation, Output } from '@angular/core';

import { Configuration } from '../../../shared/configurations/shared.config';
import { ImportFileService } from '../../services/import-file.service';
import { ImportMessageBox } from './importMessageBox/import-message-box.component';
import { ExcelService } from '../../services/excel.service';
import { Subscription } from 'rxjs';

@Component({
    moduleId: module.id,
    selector: 'importFile',
    templateUrl: 'import-file.component.html',
    providers: [ImportFileService, ExcelService],
    styleUrls: ['../../../../assets/ra/css/box-import.css'],
    encapsulation: ViewEncapsulation.None
})

export class ImportFile implements OnInit {
    @ViewChild("importMessageBox") _importMessageBox: ImportMessageBox;

    @Input() BaseURL: string;
    @Input() isBulkUploader: boolean;
    @Input() excelSheetNames: string[];
    @Input() allowedFiles: string;
    @Input() importType: string = "Vehicles"; // used to type name of the imported data to be displaed

    excelSheetData: any[];

    public importConfirmClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() onExcelDataLoaded: EventEmitter<any> = new EventEmitter<any>();

    TemplateURl: string = Configuration.urls.webApiEndpoint + Configuration.urls.importUrl;
    excelDataSubscription: Subscription;

    constructor(private excelService: ExcelService) { }

    ngOnInit() {
        this._importMessageBox.dismissClicked.subscribe(x => { this.importConfirmClicked.emit(true); });

        if (!this.isBulkUploader) {
            this.excelDataSubscription = this.excelService.onExcelDataLoaded.subscribe(data => {
                this.onExcelDataLoaded.emit(data)
            });
        }
    }

    onImportBtnClick() {
        this._importMessageBox.show();
    }

    CallRefreshList(): void {
        this.importConfirmClicked.emit(true);
    }

    ngOnDestroy() {
        if (!this.isBulkUploader) {
            this.excelDataSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/importFile/import-file.component.ts